import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type NotificationFilter = 'all' | 'unread';

interface NotificationsStore {
  notificationFilter: NotificationFilter;
  setNotificationFilter: (filter: NotificationFilter) => void;
  isPopoverOpen: boolean;
  setIsPopoverOpen: (open: boolean) => void;
}

export const useNotificationsStore = create<NotificationsStore>()(
  devtools((set) => ({
    notificationFilter: 'all',
    setNotificationFilter: (filter: NotificationFilter) =>
      set({
        notificationFilter: filter,
      }),
    isPopoverOpen: false,
    setIsPopoverOpen: (open: boolean) => set({ isPopoverOpen: open }),
  }))
);
